import PaymentField from '@apps/finance/admin/components/paymentfield'
import AmountField from '@apps/finance/admin/components/amountfield'
import Container from '@admin/components/container'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class Payment extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {
    banks: PropTypes.array,
    cards: PropTypes.array,
    invoice: PropTypes.object
  }

  state = {
    config: {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { config } = this.state
    const { invoice } = this.props
    return {
      title: 't(Receive Payment)',
      method: 'POST',
      action: `/api/admin/finance/invoices/${invoice.id}/payments`,
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Date)', name: 'date', type: 'datefield', placeholder: 'Date', required: true, defaultValue: moment() },
            { label: 't(Payment Method)', name: 'payment', type: PaymentField, contact: invoice.customer, program: invoice.program, required: true, amount: config.amount },
            { label: 't(Amount)', name: 'amount', type: AmountField, required: true, balance: invoice.balance }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

const mapResources = (props, context) => ({
  invoice: `/api/admin/finance/invoices/${props.invoice_id}`
})

export default Container(mapResources)(Payment)
